import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux'
import SolicitudComponent from './SolicitudComponent';
import estilos from './SolicitudComponent.module.css'
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'

function SolicitudesComponent(props) {


    const dispatch = useDispatch()
    const solicitudes = useSelector(store => store.AtencionSolicitud.data)
    const solicitudesStatus = useSelector(store => store.AtencionSolicitud.status)
    const [cajaBusqueda, setCajaBusqueda] = React.useState('');
    let solicitudesAux = [];
    const [aux, setAux] = React.useState([]);

    const [checkPendientes, setCheckPendientes] = React.useState(true);
    const [checkInformeEmitido, setCheckInformeEmitido] = React.useState(false);
    const [checkInformeEnRevision, setCheckInformeEnRevision] = React.useState(false);
    const [checkDictamenEmitido, setCheckDictamenEmitido] = React.useState(false);
    const [checkCompletadas, setCheckCompletadas] = React.useState(false);
    const [checkRechazadas, setCheckRechazadas] = React.useState(false);

    const handleCheckPendientes = () => {
        if (checkPendientes) { setCheckPendientes(false); }
        else { setCheckPendientes(true); setCheckInformeEmitido(false); setCheckDictamenEmitido(false); setCheckCompletadas(false); setCheckInformeEnRevision(false); setCheckRechazadas(false); }
    };
    const handleCheckInfoEmitido = () => {
        if (checkInformeEmitido) { setCheckInformeEmitido(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(true); setCheckDictamenEmitido(false); setCheckCompletadas(false); setCheckInformeEnRevision(false); setCheckRechazadas(false); }
    };
    const handleCheckInformeEnRevision = () => {
        if (checkInformeEnRevision) { setCheckInformeEnRevision(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(false); setCheckDictamenEmitido(false); setCheckCompletadas(false); setCheckInformeEnRevision(true); setCheckRechazadas(false); }
    };
    const handleCheckDictamenEmitido = () => {
        if (checkDictamenEmitido) { setCheckDictamenEmitido(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(false); setCheckDictamenEmitido(true); setCheckCompletadas(false); setCheckInformeEnRevision(false); setCheckRechazadas(false); }
    };
    const handleCheckCompletadas = () => {
        if (checkCompletadas) { setCheckCompletadas(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(false); setCheckDictamenEmitido(false); setCheckCompletadas(true); setCheckInformeEnRevision(false); setCheckRechazadas(false); }
    };
    const handleCheckRechazadas = () => {
        if (checkRechazadas) { setCheckRechazadas(false); }
        else { setCheckPendientes(false); setCheckInformeEmitido(false); setCheckDictamenEmitido(false); setCheckCompletadas(false); setCheckInformeEnRevision(false); setCheckRechazadas(true); }
    };

    React.useEffect(() => {
        if (solicitudesStatus === 0) {
            dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        }
    }, [dispatch, solicitudes.status])

    React.useEffect(() => {
        console.log("Actualiza solicitudes")
    }, [solicitudes, aux])

    const actualizarSolicitudes = () => {
        dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
    }

    React.useEffect(() => {

        solicitudesAux = solicitudes.fc_01_solicitudderegistro.filter((solicitud) => {
            if (
                solicitud.nombrerazonsocial?.toString().toUpperCase().includes(cajaBusqueda.toString().toUpperCase()) ||
                solicitud.solicitudesuifc01[0]?.inspector?.nombre.toString().toUpperCase().includes(cajaBusqueda.toString().toUpperCase()) ||
                solicitud.solicitudesuifc01[0]?.inspector?.apellidos.toString().toUpperCase().includes(cajaBusqueda.toString().toUpperCase()) ||
                solicitud.folio?.toString().toUpperCase().includes(cajaBusqueda.toString().toUpperCase())) {
                return solicitud;
            }
        });


        checkPendientes ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 1 || solicitud.solicitudesuifc01[0]?.statusdelasolicitud == undefined) : null;
        checkInformeEmitido ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 2) : null;
        checkInformeEnRevision ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 3) : null;
        checkDictamenEmitido ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 4) : null;
        checkCompletadas ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 5) : null;
        checkRechazadas ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 6) : null;
        setAux(solicitudesAux)
    }, [cajaBusqueda, checkPendientes, checkInformeEmitido, checkDictamenEmitido, checkCompletadas, solicitudes])

    const handleBuscarInstalaciones = (event) => {
        setCajaBusqueda(event.target.value);
    }

    return (
        <>

            {/* CAJA DE BUSQUEDA  */}
            <div className='row' style={{ marginLeft: '10%' }}>
                {/* 1.- Solicitud asignada al inspector
                        1.- si no ha pasado el inspector: pendiente inspeccion.
                        2.- si ya paso el inspector: informe emitido.
                        3.- si esta en proceso de revision del informe: informe en revisión.
                        4.- Si ya lo reviso el gerente: dictamen emitido.
                        5.- Cuando se finalize todo el proceso: Solictud atendida */}



                <div className='col-2'>
                    <div className="form-check" style={{ display: 'inline-block !important' }}>
                        <input className="form-check-input" type="checkbox" checked={checkPendientes} onChange={handleCheckPendientes}>
                        </input>
                        <label className="form-check-label">
                            Pendientes
                        </label>
                    </div>
                </div>
                <div className='col-2'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={checkInformeEmitido} onChange={handleCheckInfoEmitido}>
                        </input>
                        <label className="form-check-label">
                            Informe emitido
                        </label>
                    </div>
                </div>
                <div className='col-2'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={checkInformeEnRevision} onChange={handleCheckInformeEnRevision}>
                        </input>
                        <label className="form-check-label">
                            Informe en revisión
                        </label>
                    </div>
                </div>
                <div className='col-2'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={checkDictamenEmitido} onChange={handleCheckDictamenEmitido}>
                        </input>
                        <label className="form-check-label">
                            Dictámen emitido
                        </label>
                    </div>
                </div>
                <div className='col-2'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={checkCompletadas} onChange={handleCheckCompletadas}>
                        </input>
                        <label className="form-check-label">
                            Completadas
                        </label>
                    </div>
                </div>
                <div className='col-2'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={checkRechazadas} onChange={handleCheckRechazadas}>
                        </input>
                        <label className="form-check-label">
                            Rechazadas
                        </label>
                    </div>
                </div>
            </div>


            <input className='form-control' type='text' placeholder='Ingrese el nombre de la razón social, numero de solicitud o inspector' onChange={handleBuscarInstalaciones} value={cajaBusqueda}></input> <br /><hr />
            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-01: DICTAMEN DE CUMPLIMIENTO CON LA NOM INSTALACIONES:</label>
            </div>
            {
                aux.map((solicitud, index) => {
                    return (
                        <SolicitudComponent key={index} solicitud={solicitud} user={2} status={1} tipo={1} actualizarSolicitudes={actualizarSolicitudes} informerevision={handleCheckInformeEnRevision} dictamenemitido={handleCheckDictamenEmitido} completadas={handleCheckCompletadas} isCalendario={false}></SolicitudComponent>
                    )
                })
            }

            <hr></hr>
            {/*

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-09 DICTAMEN DE CUMPLIMIENTO CON LA NOM PARA PRODUCTO DE EXPORTACIÓN:</label>
            </div>
            {JSON.stringify(solicitudes.fc_09_solicitudemicioncertificadonomexportacionyentregahologram)}
            <hr></hr>

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-30 TRASLADO DE PRODUCTO EN SITIO/DOCUMENTAL</label>
            </div>
            {JSON.stringify(solicitudes.fc_30_notificaciontrasladodeproducto)}
            <hr></hr>

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-31 SOLICITUD DE SEGUIMIENTO [MUESTREO, AJUSTE DE GRADO, MEZCLA, INGRESO O LIBERACIÓN DE MADURACIÓN]</label>
            </div>
            {JSON.stringify(solicitudes.fc_31_solicitudseguimiento)}
            <hr></hr>

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>CERTIFICADO NOM PARA VENTA NACIONAL Y ENTREGA DE HOLOGRAMAS</label>
            </div>
            {JSON.stringify(solicitudes.fc_34_notificacionsuspencionyreactivacion)}
            <hr></hr>

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-34 R3 NOTIFICACIÓN DE SUSPENCIÓN O REACTIVACIÓN</label>
            </div>
            {JSON.stringify(solicitudes.fc_34_notificacionsuspencionyreactivacion)}
            <hr></hr>

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-35 SERVICIOS VARIOS</label>
            </div>
            {JSON.stringify(solicitudes.fc_35_notificaciondeserviciosvarios)}
            <hr></hr>

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-36 R3 INFORME PARA AMPLIACIÓN DE INSTALACIONES</label>
            </div>
            {JSON.stringify(solicitudes.fc_36_solicituddeactualizacion)}
            <hr></hr>

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-41 DICTAMEN DE BEBIDA ALCOHÓLICA QUE CONTIENE MEZCAL</label>
            </div>
            {JSON.stringify(solicitudes.fc_41_solicitudparabebidasconmezcal)}
            <hr></hr>
        */}
        </>
    );
}

export default withRouter(SolicitudesComponent)